import React, { ChangeEvent } from 'react'

interface Props {
  label: string
  bgColor?: string
  name?: string
  type?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  color?: string
  error?: boolean
  value?: string
}

const Input = ({
  label,
  bgColor = 'slateGray',
  name,
  type = 'text',
  onChange,
  color = 'lightIceBlue',
  value,
  error = false
}: Props) => {
  return (
    <div className="flex-1">
      <label className={`block font-sans text-14 text-${color} font-normal leading-[200%]`}>{label}</label>
      <input
        onChange={onChange}
        type={type}
        name={name}
        style={{
          borderColor: error ? '#ed4337' : '#718096',
          boxShadow: error ? '0 0 5px 2px #ed4337' : 'none'
        }}
        className={`w-[100%] font-sans bg-${bgColor} border-2 border-lightBorder p-4
                   rounded-lg font-light text-14 text-${color}
                    placeholder-${color} outline-none`}
        placeholder={label}
        value={value}
      />
    </div>
  )
}

export default Input
